import Joi from 'joi';
import { EVENT_DATA_FIELD_KEYS, METRIC_DATA_FIELD_KEYS, CUSTOM_EVENT_DATA_FIELD_KEY_REGEX } from './dataFieldKeys';
export const MAX_CALCULATION_METRICS = 6;

export const V1_CALCULATION = 'v1_calc' as const;

export const WHITELISTED_EVENTS = Object.values(EVENT_DATA_FIELD_KEYS);
export const WHITELISTED_METRICS = Object.values(METRIC_DATA_FIELD_KEYS);

export const MATH_OPERATORS = ['+', '-', '*', '/', '(', ')'];
export const MATH_OPERATORS_SET = new Set(MATH_OPERATORS);

const eventSchema = Joi.string().valid(...WHITELISTED_EVENTS);
const metricSchema = Joi.string().valid(...WHITELISTED_METRICS);
const customEventSchema = Joi.string().regex(CUSTOM_EVENT_DATA_FIELD_KEY_REGEX);
const numberSchema = Joi.string().regex(/^\d+(\.\d+)?$/);
const mathOperatorsSchema = Joi.string().valid(...MATH_OPERATORS);

export const V1_CALCULATION_EQUATION_SCHEMA = Joi.array()
  .items(numberSchema, mathOperatorsSchema, eventSchema, metricSchema, customEventSchema)
  .min(1);

export const SHORT_ERROR = {
  NOT_ARRAY: 'not_array',
  EMPTY_EQUATION: 'empty_equation',
  UNEXPECTED_VALUE: 'unexpected_value',
  TOO_MANY_DATAFIELDS: 'too_many_datafields',
  NO_DATAFIELDS: 'no_datafields',
  PARSING_ERROR: 'parsing_error',
};

export const VARIABLE_TYPE = {
  EVENT: 'event',
  METRIC: 'metric',
};

export const SELECTED_CUSTOM_CALCULATIONS_MAX = 2;

export const MAX_APP_CALCULATIONS = 3;
export const MAX_USER_CALCULATIONS = 3;
